/**
 * Vocabulary: readers see this feature as "owner reviews"; code, routes, DealHunt paths and
 * analytics events keep the historical "owner note" name on purpose — do not rename them.
 *
 * Proposal 4: the collapsed example under the capture band — the aggregate block a
 * reader's answers feed, then one note card. Constants, never real data: a neutral
 * pseudonym, the default question labels, "Owner-reported". Labelled as an example
 * wherever it renders (an unlabelled sample reads as a real owner claim, #55/#68).
 */
import type { OwnerAggregate, OwnerNotePublic } from 'lib/dealhunt/types'

export const EXAMPLE_AGGREGATE: OwnerAggregate = {
  published_count: 3,
  photo_verified: 1,
  buy_again_pct: null,
  buy_again_yes: 2,
  median_ownership_bucket: '6_12m',
  reads: [
    {
      id: 'comfort',
      label: 'Comfort over long sessions',
      better: 2,
      expected: 1,
      worse: 0,
      answers: 3,
    },
    { id: 'battery', label: 'Battery in real life', better: 1, expected: 1, worse: 1, answers: 3 },
    { id: 'mic', label: 'Mic on calls', better: 0, expected: 3, worse: 0, answers: 3 },
    {
      id: 'build',
      label: 'Fit and build after months',
      better: 1,
      expected: 0,
      worse: 2,
      answers: 3,
    },
  ],
  use_cases: [],
  hours_median: null,
  claimed_hours: null,
  gave_out: [],
}

export const EXAMPLE_NOTE: OwnerNotePublic = {
  id: 'example',
  node_id: 'example',
  handle: 'quiet_kestrel_47',
  note: 'The case lid loosened after a few months; the ANC still surprises me on trains.',
  answers: {
    ownership_length: '6_12m',
    still_using: 'yes',
    use_cases: ['commute'],
    reads: { comfort: 'better', battery: 'expected', build: 'worse' },
    gave_out: null,
    hours_per_charge: null,
    buy_again: true,
  },
  photo_status: 'none',
  photo_label: 'Owner-reported',
  published_at: '2026-09-01T00:00:00Z',
  edited_at: null,
  proofread: false,
}
